import React from 'react';
import { Navbar } from '../../components';
import { ContactHeader } from '../../containers';

const Contact = () => {
  return (
    <div>
        <div className="gradient__bg">
          <Navbar />
          <ContactHeader />
        </div>
    </div>
  )
}

export default Contact